import { GET_PAYMENTS, GET_ACCRUALS } from "./types";

export default {
  [GET_PAYMENTS]: (state, paymentsList) => {
    state.payments = paymentsList.map(counter =>
      Object.assign(counter, { newValue: null })
    );
  },

  [GET_ACCRUALS]: (state, accrualsList) => {
    state.accruals = accrualsList;
  }
};
